import { render, staticRenderFns } from "./NameHighlight.vue?vue&type=template&id=5bfc8f3c&scoped=true&"
import script from "./NameHighlight.vue?vue&type=script&lang=js&"
export * from "./NameHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc8f3c",
  null
  
)

export default component.exports